import BadWords from 'bad-words';

const badWordsFilter = new BadWords();

const isProfane = value => badWordsFilter.isProfane(value);

export default isProfane;
